import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "@/components/layout/DashboardLayout";
const Overview = lazy(() => import("@/pages/Overview"));
const Shipments = lazy(() => import("@/pages/Shipments"));
const Fleet = lazy(() => import("@/pages/Fleet"));
const Analytics = lazy(() => import("@/pages/Analytics"));
const Reports = lazy(() => import("@/pages/Reports"));
const Comparison = lazy(() => import("@/pages/Comparison"));
const AlvysLive = lazy(() => import("@/pages/AlvysLive"));
const LoadDetail = lazy(() => import("@/pages/LoadDetail"));
const SamsaraLive = lazy(() => import("@/pages/SamsaraLive"));
const TrucksOnRoad = lazy(() => import("@/pages/TrucksOnRoad"));
const DriverScorecard = lazy(() => import("@/pages/DriverScorecard"));
const DispatcherLeaderboard = lazy(() => import("@/pages/DispatcherLeaderboard"));
const DataFixes = lazy(() => import("@/pages/DataFixes"));
const DispatcherRankings = lazy(() => import("@/pages/DispatcherRankings"));
const DispatcherDrillDown = lazy(() => import("@/pages/DispatcherDrillDown"));
const FleetMap = lazy(() => import("@/pages/FleetMap"));
const DispatcherComparison = lazy(() => import("@/pages/DispatcherComparison"));
const LoadHeatmap = lazy(() => import("@/pages/LoadHeatmap"));
const FuelReport = lazy(() => import("@/pages/FuelReport"));
const RelayFuel = lazy(() => import("@/pages/RelayFuel"));

import Login from "@/pages/Login";
const SetPassword = lazy(() => import("@/pages/SetPassword"));
const Users = lazy(() => import("@/pages/Users"));
const OrientELD = lazy(() => import("@/pages/OrientELD"));
const IftaTax = lazy(() => import("@/pages/IftaTax"));
import RequireAuth from "@/components/layout/RequireAuth";
import { AuthProvider } from "@/context/AuthContext";
import { WeekSettingsProvider } from "@/context/WeekSettingsContext";

function App() {
  return (
    <AuthProvider>
    <WeekSettingsProvider>
      <BrowserRouter>
      <Suspense fallback={<div data-testid="page-loading" className="p-8 text-sm text-slate-500">Loading...</div>}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route element={<RequireAuth><DashboardLayout /></RequireAuth>}>
          <Route path="/users" element={<Users />} />
          <Route path="/" element={<Overview />} />
          <Route path="/routes" element={<Navigate to="/" replace />} />
          <Route path="/shipments" element={<Shipments />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/comparison" element={<Comparison />} />
          <Route path="/alvys" element={<AlvysLive />} />
          <Route path="/alvys/load/:loadNumber" element={<LoadDetail />} />
          <Route path="/samsara" element={<SamsaraLive />} />
          <Route path="/orient" element={<OrientELD />} />
          <Route path="/ifta" element={<IftaTax />} />
          <Route path="/trucks-on-road" element={<TrucksOnRoad />} />
          <Route path="/driver-scorecard" element={<DriverScorecard />} />
          <Route path="/dispatcher-leaderboard" element={<DispatcherLeaderboard />} />
          <Route path="/dispatcher-rankings" element={<DispatcherRankings />} />
          <Route path="/data-fixes" element={<DataFixes />} />
          <Route path="/dispatcher/:id" element={<DispatcherDrillDown />} />
          <Route path="/fleet-map" element={<FleetMap />} />
          <Route path="/dispatcher-comparison" element={<DispatcherComparison />} />
          <Route path="/load-heatmap" element={<LoadHeatmap />} />
          <Route path="/fuel-report" element={<FuelReport />} />
          <Route path="/relay-fuel" element={<RelayFuel />} />
        </Route>
      </Routes>
      </Suspense>
    </BrowserRouter>
    </WeekSettingsProvider>
    </AuthProvider>
  );
}

export default App;
